module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/237-netherlands-c434f7c9da35eefe593e69c09a4bdd41.svg";